import {
  INotification,
  notificationEnums,
} from "@freetech/models/notifications";

export const getFreeloNotificationTitle = (
  notification: INotification
): string | undefined => {
  const { type, afterData, beforeData } = notification;

  switch (type) {
    case notificationEnums.FreeloNotificationType.FREELO_BOARD_CREATED:
      if (afterData && "name" in afterData) {
        return `New Freelo board: ${afterData.name}`;
      }
      return "New Freelo board created";

    case notificationEnums.FreeloNotificationType.FREELO_BOARD_UPDATED:
      if (afterData && "name" in afterData) {
        return `Freelo board updated: ${afterData.name}`;
      }
      return "Freelo board updated";

    case notificationEnums.FreeloNotificationType.FREELO_BOARD_DELETED:
      if (beforeData && "name" in beforeData) {
        return `Freelo board deleted: ${beforeData.name}`;
      }
      return "Freelo board deleted";

    case notificationEnums.FreeloNotificationType.FREELO_CARD_CREATED:
      if (afterData && "name" in afterData && "boardName" in afterData) {
        return `New card: ${afterData.name} (${afterData.boardName})`;
      }
      if (afterData && "name" in afterData) {
        return `New card: ${afterData.name}`;
      }
      return "New card created";

    case notificationEnums.FreeloNotificationType.FREELO_CARD_UPDATED:
      if (afterData && "name" in afterData) {
        return `Card updated: ${afterData.name}`;
      }
      return "Card updated";

    case notificationEnums.FreeloNotificationType.FREELO_CARD_DELETED:
      if (beforeData && "name" in beforeData) {
        return `Card deleted: ${beforeData.name}`;
      }
      return "Card deleted";

    case notificationEnums.FreeloNotificationType.FREELO_CARD_ASSIGNED:
      if (afterData && "name" in afterData) {
        return `Assigned to card: ${afterData.name}`;
      }
      return "Card assigned to you";

    case notificationEnums.FreeloNotificationType.FREELO_CARD_COMMENT_MENTION:
      if (
        afterData &&
        "cardName" in afterData &&
        "commenterName" in afterData
      ) {
        return `${afterData.commenterName} mentioned you in: ${afterData.cardName}`;
      }
      return "You were mentioned in a comment";

    case notificationEnums.FreeloNotificationType.FREELO_CARD_STATUS_CHANGED:
      if (
        afterData &&
        beforeData &&
        "status" in afterData &&
        "status" in beforeData &&
        "name" in afterData
      ) {
        return `${afterData.name}: ${beforeData.status} → ${afterData.status}`;
      }
      return "Card status changed";

    case notificationEnums.FreeloNotificationType.FREELO_DEADLINE_APPROACHING:
      if (afterData && "name" in afterData && "dueDate" in afterData) {
        const dueDate = new Date(afterData.dueDate as string);
        return `Deadline approaching: ${afterData.name} (due ${dueDate.toLocaleDateString()})`;
      }
      return "Card deadline approaching";

    default:
      return undefined;
  }
};
